import { render, staticRenderFns } from "./unauthorized.component.vue?vue&type=template&id=844dd758&scoped=true"
import script from "./unauthorized.component.ts?vue&type=script&lang=ts&external"
export * from "./unauthorized.component.ts?vue&type=script&lang=ts&external"
import style0 from "./unauthorized.component.vue?vue&type=style&index=0&id=844dd758&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "844dd758",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('844dd758')) {
      api.createRecord('844dd758', component.options)
    } else {
      api.reload('844dd758', component.options)
    }
    module.hot.accept("./unauthorized.component.vue?vue&type=template&id=844dd758&scoped=true", function () {
      api.rerender('844dd758', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client/unauthorized/unauthorized.component.vue"
export default component.exports